import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
export default function AeroStag() {
  const aerostage = useRef(null);
  const udaan = useRef(null);
  const safar = useRef(null);
  const zaika = useRef(null);
  const location = useLocation();

  const settings = {
    dots: false, // Dots indicators
    infinite: true, // Infinite scroll
    speed: 1200,
    slidesToShow: 1, // 3 cards in one row
    slidesToScroll: 1, // Scroll by 1 card
    autoplay: true, // Auto scroll
    autoplaySpeed: 5000, // 2 sec per slide
    arrows: true, // Left/Right arrows
    responsive: [
      {
        breakpoint: 768, // Mobile screen
        settings: {
          slidesToShow: 1, // Show 1 card on mobile
        }
      }
      ,
    
    ]
  };
   const [modalId, setModalId] = useState(null);
  
    const openModal = (id) => {
      setModalId(id);
    };
  
    const closeModal = () => {
      setModalId(null);
    };

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const hash = location.hash;
        if (hash === '#aerostag' && aerostage.current) {
          aerostage.current?.scrollIntoView({ behavior: 'smooth' });
        } else if (hash === '#safar' && safar.current) {
          safar.current?.scrollIntoView({ behavior: 'smooth' });
        } else if (hash === '#zaika' && zaika.current) {
          zaika.current?.scrollIntoView({ behavior: 'smooth' });
        } else if (hash === '#udaan' && udaan.current) {
          udaan.current?.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100); 
    }
  }, [location]);

  return (
    <>
 <Helmet>
        <title>Exquisite Dining Experience | V Hotel The Grand Shoba</title>
        <meta name="description" content="Aero Stag offers a unique dining experience with both elegant indoor seating and breezy poolside ambiance. Enjoy live music, TV shows, and cricket on a wide screen or turn the space into your own private cinema hall. Whether you're relaxing outdoors or immersed indoors, our delicious food, refreshing beverages, and vibrant atmosphere make Aero Stag the perfect spot for memorable moments and flavorful indulgence." />
        <meta name="keywords" content="dining, restaurants, IGI Airport, mocktails, fine dining, V Hotel The Grand Shoba" />
        <meta property="og:title" content="Exquisite Dining Experience | V Hotel The Grand Shoba" />
        <meta property="og:description" content="Indulge in delectable dishes, enjoy mocktails, and unwind in a trendy ambiance at V Hotel The Grand Shoba's premium dining outlets." />
        <meta property="og:image" content="/images/dine/dine-2/dine-2.jpg" />
        {/* <meta property="og:url" content="https://yourwebsite.com/dining" /> */}
      </Helmet>


    <div className="seventh-main">
        <img title='diningImageTitle'  src="/images/dine/dine-2/dine-2.jpg" alt="seventh-sense-images" />
        <div className="aero-stage-hero " >
          <span className='aerostag aerostag-desk'>AERO-STAG</span>
        </div>
        
    </div>
    {/* desktop screen card */}
    <div className="container seventh-desktop-screen mt-5">
    <div className="dine-main-des mb-5">
                <p className='text-center'>At V Hotel The Grand Shoba, we're renowned for offering a wide range of exquisite cuisines at our premium dining outlets. Enjoy a variety of delicious dishes, refresh with our signature mocktails at the bar, and unwind in a trendy ambiance with great music. Experience top-tier dining and beverages during your stay, just minutes from IGI Airport.</p>
            </div>
            {/* 1st type card */}
        <div className="row"  id='aero'>
            
            <div className="col-md-6 seventh-slider-main">
              <div className="seventh-slider">
              <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
               <div className="carousel-inner">
                 <div className="carousel-item active">
                   <img title='V Hotel The Grnad Shoba aero stage' loading='lazy' src="/images/dine/dine-2/dine-2.jpg" alt="V Hotel The Grnad Shoba aerostage1" className="d-block w-100" onClick={() => openModal(1)} />
                </div>
               <div className="carousel-item">
                 <img title='V Hotel The Grnad Shoba aero stage' loading='lazy' src="/images/dine/dine-2/dine-2-2.jpg"alt="V Hotel The Grnad Shoba aero stage2" className="d-block w-100" onClick={() => openModal(1)} />
               </div>
               <div className="carousel-item">
                <img title='V Hotel The Grnad Shoba aero stage' loading='lazy' src="/images/dine/dine-2/dine-2-3.jpg" alt="V Hotel The Grnad Shoba dining aero stag3" className="d-block w-100" onClick={() => openModal(1)} />
            </div>
        </div>
          </div>
              </div>
          
            </div>

            <div className="col-md-6">
                <div className="seventh-sense-right" id='aero-stag'>
                    <h1>AERO-STAG</h1>
                    <div className="seventh-para">
                      <p>Aero Stag offers a unique dining experience with both elegant indoor seating and breezy poolside ambiance. Enjoy live music, TV shows, and cricket on a wide screen or turn the space into your own private cinema hall. Whether you're relaxing outdoors or immersed indoors, our delicious food, refreshing beverages, and vibrant atmosphere make Aero Stag the perfect spot for memorable moments and flavorful indulgence.</p>
                    </div>
                    <div className="seventh-time-main">
                        <p className='seventh-open'>Opening Hours:</p>
                        <p className='seventh-time'>07:00 AM - 11:00 PM</p>
                        <p className='seventh-days'>Monday - Sunday</p>
                    </div>
                    <div className="row g-2">
                     {/* <div className="col-12 col-md-auto seventh-call-btn-main">
                      <Link to="/menu"> <button  className=" seventh-call-btn">Menu</button></Link>
                     </div> */}
                     <div className="col-12 col-md-auto seventh-call-btn-main">
                       
                     <Link to="/menu"> <button  className=" seventh-call-btn">Menu</button></Link>

                     </div>
                        <div className="col-12 col-md-auto">
                        <Link to="/query"> <button  className="seventh-query-btn">Reserve  Now</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

             {/* 2st type card */}
        <div className="row mt-3"   id='udaan'>

            <div className="col-md-6">
                <div className="seventh-sense-right" >
                    <h1>SAFAR</h1>
                    <div className="seventh-para">
                    <p>A Safar is our signature indoor restaurant serving a delightful blend of traditional and modern cuisine. With warm interiors and attentive service, it offers a cozy setting to enjoy delicious meals crafted from the finest ingredients. A perfect destination for family dinners, quiet lunches, or a flavorful culinary escape.</p>
                    </div>
                    <div className="seventh-time-main">
                        <p className='seventh-open'>Opening Hours:</p>
                        <p className='seventh-time'>07:00 AM - 11:00 PM</p>
                        <p className='seventh-days'>Monday - Sunday</p>
                    </div>
                    <div className="row g-2">
                     <div className="col-12 col-md-auto seventh-call-btn-main">
                     <Link to="/menu"> <button  className=" seventh-call-btn">Menu</button></Link>
                     
                       
                     </div>
                        <div className="col-12 col-md-auto">
                        <Link to="/query"> <button  className="seventh-query-btn">Reserve  Now</button></Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-6 seventh-slider-main">
              
                <div className="seventh-slider">
  <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
   <div className="carousel-inner">
     <div className="carousel-item active">
       <img title='V Hotel The Grnad Shoba dining safar' loading='lazy' src="/images/dine/dine-3/dine-3.jpg" alt="V Hotel The Grnad Shoba dining safar1" onClick={() => openModal(2)} className="d-block w-100" />
    </div>
   <div className="carousel-item">
     <img title='V Hotel The Grnad Shoba dining safar' loading='lazy' src="/images/dine/dine-3/dine-3-2.jpg" alt="V Hotel The Grnad Shoba dining safar2" onClick={() => openModal(2)} className="d-block w-100" />
   </div>
   <div className="carousel-item">
    <img title='V Hotel The Grnad Shoba dining safar' loading='lazy' src="/images/dine/dine-3/dine-3-3.jpg" alt="V Hotel The Grnad Shoba dining safar3" onClick={() => openModal(2)} className="d-block w-100" />
</div>
</div>
</div>
  </div>
          
            </div>
        </div>


             {/* 1st type card */}
        <div className="row mt-3" id='zaika'>
            
            <div className="col-md-6 seventh-slider-main">
              
              
              <div className="seventh-slider">
              <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
               <div className="carousel-inner">
                 <div className="carousel-item active">
                   <img title='V Hotel The Grnad Shoba dining udaan' loading='lazy' src="/images/dine/udaan/udaan1.jpg" alt="V Hotel The Grnad Shoba dining udaan1" onClick={() => openModal(3)} className="d-block w-100" />
               
                </div>
               <div className="carousel-item">
                 <img title='V Hotel The Grnad Shoba dining udaan' loading='lazy' src="/images/dine/udaan/udaan2.jpg" alt="V Hotel The Grnad Shoba dining udaan2" onClick={() => openModal(3)} className="d-block w-100" />
               </div>
               <div className="carousel-item">
                <img title='V Hotel The Grnad Shoba dining udaan' loading='lazy' src="/images/dine/udaan/udaan3.jpg"  alt="V Hotel The Grnad Shoba dining udaan3" onClick={() => openModal(3)} className="d-block w-100" />
            </div>
        </div>
          </div>
              </div>
          
            </div>

            <div className="col-md-6">
                <div className="seventh-sense-right">
                    <h1>UDAAN</h1>
                    <div className="seventh-para">
                       <p>Udaan, located near the airport, is aptly named after the spirit of takeoff. Just like flights soaring high, Udaan lifts your dining experience with delicious food and a welcoming ambiance. Whether you're arriving, departing, or just craving great taste, enjoy a perfect meal inspired by freshness, flavor, and flight.</p>
                    </div>
                    <div className="seventh-time-main">
                        <p className='seventh-open'>Opening Hours:</p>
                        <p className='seventh-time'>07:00 AM - 11:00 PM</p>
                        <p className='seventh-days'>Monday - Sunday</p>
                    </div>
                    <div className="row g-2">
                     <div className="col-12 col-md-auto seventh-call-btn-main">
                      <Link to="/menu"> <button  className=" seventh-call-btn">Menu</button></Link>
                     </div>
                        <div className="col-12 col-md-auto">
                        <Link to="/query"> <button  className="seventh-query-btn">Reserve  Now</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>


               {/* 2st type card */}
               <div className="row mt-3"  id='safar'>

<div className="col-md-6">
    <div className="seventh-sense-right">
        <h1>ZAIKA</h1>
        <div className="seventh-para">
                              <p>Zaika brings the bold and diverse tastes of Delhi to your plate, with a special emphasis on irresistible non-vegetarian specialities. Our skilled chefs craft each dish using time-honoured recipes and authentic spices, delivering a true culinary experience. Step into our cosy indoor space and savour the essence of Delhi’s rich food culture perfect for anyone who loves great food.</p>

        </div>
        <div className="seventh-time-main">
            <p className='seventh-open'>Opening Hours:</p>
            <p className='seventh-time'>07:00 AM - 11:00 PM</p>
            <p className='seventh-days'>Monday - Sunday</p>
        </div>
        <div className="row g-2">
         <div className="col-12 col-md-auto seventh-call-btn-main">
          <Link to="/menu"> <button  className=" seventh-call-btn">Menu</button></Link>
         </div>
            <div className="col-12 col-md-auto">
            <Link to="/query"> <button  className="seventh-query-btn">Reserve  Now</button></Link>
            </div>
        </div>
    </div>
</div>

<div className="col-md-6 seventh-slider-main">
  <div className="seventh-slider">
  <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
   <div className="carousel-inner">
     <div className="carousel-item active">
       <img title='V Hotel The Grnad Shoba dining zaika' loading='lazy' src="/images/dine/dine-1/dine-1.jpg"  alt="V Hotel The Grnad Shoba dining zaika1" onClick={() => openModal(4)} className="d-block w-100" />
    </div>
   <div className="carousel-item">
     <img title='V Hotel The Grnad Shoba dining zaika' loading='lazy' src="/images/dine/dine-1/dine-1-2.jpg"  alt="V Hotel The Grnad Shoba dining zaika" onClick={() => openModal(4)} className="d-block w-100" />
   </div>
   <div className="carousel-item">
    <img title='V Hotel The Grnad Shoba dining zaika' loading='lazy' src="/images/dine/dine-1/dine-1-3.jpg"  alt="V Hotel The Grnad Shoba dining zaika" onClick={() => openModal(4)} className="d-block w-100" />
</div>
</div>
</div>
  </div>

</div>
              </div>


                  {/* 1st type card */}
            {/* <div className="row mt-3">
            
            <div className="col-md-6 seventh-slider-main">
              <div className="seventh-slider">
              <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
               <div className="carousel-inner">
                 <div className="carousel-item active">
                   <img title='diningImageTitle' loading='lazy' src="/images/hero_1.jpg" className="d-block w-100" alt="dine images1"/>
                </div>
               <div className="carousel-item">
                 <img title='diningImageTitle' loading='lazy' src="/images/hero_2.jpg" className="d-block w-100" alt="dine images2"/>
               </div>
               <div className="carousel-item">
                <img title='diningImageTitle' src="images/hero_2.jpg" className="d-block w-100" alt="dine images3"/>
            </div>
        </div>
          </div>
              </div>
          
            </div>

            <div className="col-md-6">
                <div className="seventh-sense-right">
                    <h1>The Bar</h1>
                    <div className="seventh-para">
                      <p>Get swept away by the huge variety and enticing aromas of Indian, Chinese, Thai, Japanese, Continental, Italian, Mediterranean, Lebanese and French cuisines at our open dining outlet, Seventh Sense. With a capacity to host 150 guests, a wine cellar, and seven live kitchens, we serve here hot and fresh foods on both buffet and A-la-carte. Visit for luxury 5 star fine dini</p>
                    </div>
                    <div className="seventh-time-main">
                        <p className='seventh-open'>Opening Hours:</p>
                        <p className='seventh-time'>07:00 AM - 11:00 PM</p>
                        <p className='seventh-days'>Monday - Sunday</p>
                    </div>
                    <div className="row g-2">
                     <div className="col-12 col-md-auto seventh-call-btn-main">
                      <Link to="/menu"> <button  className=" seventh-call-btn">Menu</button></Link>
                     </div>
                        <div className="col-12 col-md-auto">
                        <Link to="/query"> <button  className="seventh-query-btn">Reserve  Now</button></Link>
                        </div>
                    </div>
                </div>
            </div>
            </div> */}
    </div>
    
{/* -----------------------MOBILE SCREEN--------------------------- */}
    {/* mobile screen card */}
    <div className="container seventh-mobile-screen mt-5">
    <div className="dine-main-des mb-5">
                <p className='text-center'>Good food is something for which we have been known for a long time now and the huge variety of delicious food that we offer at our dining outlets is a testament of that. During your stay here, indulge in an array of sumptuous cuisines at our dining outlets or relax and sip on some premium spirits at our bar amidst good music in a trendy ambience. The choice is all yours.</p>
            </div>
            {/* 1st type card */}
        <div className="row mt-5" ref={aerostage}>
            
            <div className="col-md-6 seventh-slider-main">
              <div className="seventh-slider">
              <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
               <div className="carousel-inner">
                 <div className="carousel-item active">
                   <img title='V Hotel The Grnad Shoba dining aero stag' loading='lazy' src="/images/dine/dine-2/dine-2.jpg"alt="V Hotel The Grnad Shoba dining aero stag1" onClick={() => openModal(1)} className="d-block w-100"/>
                </div>
               <div className="carousel-item">
                 <img title='V Hotel The Grnad Shoba dining aero stag' loading='lazy' src="/images/dine/dine-1/dine-1-2.jpg"alt="V Hotel The Grnad Shoba dining aero stag 2" onClick={() => openModal(1)} className="d-block w-100" />
               </div>
               <div className="carousel-item">
                <img title='V Hotel The Grnad Shoba dining aero stag' loading='lazy' src="/images/dine/dine-1/dine-1-3.jpg"alt="V Hotel The Grnad Shoba dining aero stag3" onClick={() => openModal(1)} className="d-block w-100" />
            </div>
        </div>
          </div>
              </div>
          
            </div>

            <div className="col-md-6">
                <div className="seventh-sense-right">
                    <h1>AERO-STAG</h1>
                    <div className="seventh-para">
                      <p>Aero Stag offers a unique dining experience with both elegant indoor seating and breezy poolside ambiance. Enjoy live music, TV shows, and cricket on a wide screen or turn the space into your own private cinema hall. Whether you're relaxing outdoors or immersed indoors, our delicious food, refreshing beverages, and vibrant atmosphere make Aero Stag the perfect spot for memorable moments and flavorful indulgence.</p>
                    </div>
                    <div className="seventh-time-main">
                        <p className='seventh-open'>Opening Hours:</p>
                        <p className='seventh-time'>07:00 AM - 11:00 PM</p>
                        <p className='seventh-days'>Monday - Sunday</p>
                    </div>
                    <div className="row g-2">
                     <div className="col-12 col-md-auto seventh-call-btn-main">
                      <Link to="/menu"> <button  className=" seventh-call-btn">Menu</button></Link>
                     </div>
                        <div className="col-12 col-md-auto">
                        <Link to="/query"> <button  className="seventh-query-btn">Reserve  Now</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="row mt-5" ref={safar}>
<div className="col-md-6 seventh-slider-main">
  <div className="seventh-slider">
  <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
   <div className="carousel-inner">
     <div className="carousel-item active">
       <img title='V Hotel The Grnad Shoba dining safar' loading='lazy' src="/images/dine/dine-3/dine-3.jpg" alt="V Hotel The Grnad Shoba dining safar1" onClick={() => openModal(2)} className="d-block w-100" />
    </div>
   <div className="carousel-item">
     <img title='V Hotel The Grnad Shoba dining safar' loading='lazy' src="/images/dine/dine-3/dine-3-2.jpg" alt="V Hotel The Grnad Shoba dining safar2" onClick={() => openModal(2)} className="d-block w-100" />
   </div>
   <div className="carousel-item">
    <img title='V Hotel The Grnad Shoba dining safar' loading='lazy' src="/images/dine/dine-1/dine-1-3.jpg" alt="V Hotel The Grnad Shoba dining safar3" onClick={() => openModal(2)} className="d-block w-100" />
</div>
<div className="carousel-item">
    <img title='V Hotel The Grnad Shoba dining safar' loading='lazy' src="/images/dine/dine-3/dine-3-3.jpg" alt="V Hotel The Grnad Shoba dining safar4" onClick={() => openModal(2)} className="d-block w-100" />
</div>
</div>
</div>
  </div>

</div>
<div className="col-md-6">
    <div className="seventh-sense-right">
        <h1>SAFAR</h1>
        <div className="seventh-para">
          <p>A Safar is our signature indoor restaurant serving a delightful blend of traditional and modern cuisine. With warm interiors and attentive service, it offers a cozy setting to enjoy delicious meals crafted from the finest ingredients. A perfect destination for family dinners, quiet lunches, or a flavorful culinary escape.</p>
        </div>
        <div className="seventh-time-main">
            <p className='seventh-open'>Opening Hours:</p>
            <p className='seventh-time'>07:00 AM - 11:00 PM</p>
            <p className='seventh-days'>Monday - Sunday</p>
        </div>
        <div className="row g-2">
         <div className="col-12 col-md-auto seventh-call-btn-main">
          <Link to="/menu"> <button  className=" seventh-call-btn">Menu</button></Link>
         </div>
            <div className="col-12 col-md-auto">
            <Link to="/query"> <button  className="seventh-query-btn">Reserve  Now</button></Link>
            </div>
        </div>
    </div>
</div>


              </div>
             {/* 2st type card */}
        <div className="row mt-5" ref={udaan}>

            <div className="col-md-6 seventh-slider-main">
              <div className="seventh-slider">
              <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
               <div className="carousel-inner">
                 <div className="carousel-item active">
                   <img title='V Hotel The Grnad Shoba dining udaan' loading='lazy' src="/images/dine/udaan/udaan1.jpg" alt="V Hotel The Grnad Shoba dining udaan1" onClick={() => openModal(3)} className="d-block w-100" />
                </div>
               <div className="carousel-item">
                 <img title='V Hotel The Grnad Shoba dining udaan' loading='lazy' src="/images/dine/udaan/udaan2.jpg" alt="V Hotel The Grnad Shoba dining udaan2" onClick={() => openModal(3)} className="d-block w-100" />
               </div>
               <div className="carousel-item">
                <img title='V Hotel The Grnad Shoba dining udaan' loading='lazy' src="/images/dine/udaan/udaan3.jpg" alt="V Hotel The Grnad Shoba dining udaan3" onClick={() => openModal(3)} className="d-block w-100" />
            </div>
        </div>
          </div>
              </div>
          
            </div>
            <div className="col-md-6">
                <div className="seventh-sense-right">
                    <h1>UDAAN</h1>
                    <div className="seventh-para">
                      <p>Udaan, located near the airport, is aptly named after the spirit of takeoff. Just like flights soaring high, Udaan lifts your dining experience with delicious food and a welcoming ambiance. Whether you're arriving, departing, or just craving great taste, enjoy a perfect meal inspired by freshness, flavor, and flight.</p>
                    </div>
                    <div className="seventh-time-main">
                        <p className='seventh-open'>Opening Hours:</p>
                        <p className='seventh-time'>07:00 AM - 11:00 PM</p>
                        <p className='seventh-days'>Monday - Sunday</p>
                    </div>
                    <div className="row g-2">
                     <div className="col-12 col-md-auto seventh-call-btn-main">
                      <Link to="/menu"> <button  className=" seventh-call-btn">Menu</button></Link>
                     </div>
                        <div className="col-12 col-md-auto">
                        <Link to="/query"> <button  className="seventh-query-btn">Reserve  Now</button></Link>
                        </div>
                    </div>
                </div>
            </div>

        </div>


             {/* 1st type card */}
        <div className="row mt-5"ref={zaika}>
            
            <div className="col-md-6 seventh-slider-main">
              <div className="seventh-slider">
              <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
               <div className="carousel-inner">
                 <div className="carousel-item active">
                   <img title='V Hotel The Grnad Shoba dining zaika' loading='lazy' src="/images/dine/dine-1/dine-1.jpg"  alt="V Hotel The Grnad Shoba dining zaika1" onClick={() => openModal(4)} className="d-block w-100" />
                </div>
               <div className="carousel-item">
                 <img title='V Hotel The Grnad Shoba dining zaika' loading='lazy' src="/images/dine/dine-1/dine-1-2.jpg" alt="V Hotel The Grnad Shoba dining zaika2" onClick={() => openModal(4)} className="d-block w-100" />
               </div>
               <div className="carousel-item">
                <img title='V Hotel The Grnad Shoba dining zaika' loading='lazy' src="/images/dine/dine-1/dine-1-3.jpg" alt="V Hotel The Grnad Shoba dining zaika3" onClick={() => openModal(4)} className="d-block w-100" />
            </div>
        </div>
          </div>
              </div>
          
            </div>

            <div className="col-md-6">
                <div className="seventh-sense-right">
                    <h1>ZAIKA</h1>
                    <div className="seventh-para">
                      <p>Zaika brings the bold and diverse tastes of Delhi to your plate, with a special emphasis on irresistible non-vegetarian specialities. Our skilled chefs craft each dish using time-honoured recipes and authentic spices, delivering a true culinary experience. Step into our cosy indoor space and savour the essence of Delhi’s rich food culture perfect for anyone who loves great food.</p>
                    </div>
                    <div className="seventh-time-main">
                        <p className='seventh-open'>Opening Hours:</p>
                        <p className='seventh-time'>07:00 AM - 11:00 PM</p>
                        <p className='seventh-days'>Monday - Sunday</p>
                    </div>
                    <div className="row g-2">
                     <div className="col-12 col-md-auto seventh-call-btn-main">
                      <Link to="/menu"> <button  className=" seventh-call-btn">Menu</button></Link>
                     </div>
                        <div className="col-12 col-md-auto">
                        <Link to="/query"> <button  className="seventh-query-btn">Reserve  Now</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>



 






{/* modal aero stag */}

 {modalId === 1 && (
        <div className="modal fade show" style={{ display: "block" }}  aria-labelledby="exampleModalLabel" aria-hidden="false">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Aero-Stag</h1>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
<div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img title='V Hotel The Grnad Shoba dining aero stag' loading='lazy' src="/images/dine/dine-2/dine-2.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining aero stag1"/>
    </div>
    <div className="carousel-item">
      <img title='V Hotel The Grnad Shoba dining aero stag' loading='lazy' src="/images/dine/dine-2/dine-2-2.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining aero stag2"/>
    </div>
    <div className="carousel-item">
      <img title='V Hotel The Grnad Shoba dining aero stag' loading='lazy' src="/images/dine/dine-2/dine-2-3.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining aero stag3"/>
    </div>
     <div className="carousel-item">
      <img title='V Hotel The Grnad Shoba dining aero stag' loading='lazy' src="/images/dine/dine-2/dine-2-4.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining aero stag4"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
        <p>Aero Stag offers a unique dining experience with both elegant indoor seating and breezy poolside ambiance. Enjoy live music, TV shows, and cricket on a wide screen or turn the space into your own private cinema hall. Whether you're relaxing outdoors or immersed indoors, our delicious food, refreshing beverages, and vibrant atmosphere make Aero Stag the perfect spot for memorable moments and flavorful indulgence.</p>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}


{/* modal safar */}

 {modalId === 2 && (
        <div className="modal fade show" style={{ display: "block" }}  aria-labelledby="exampleModalLabel" aria-hidden="false">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Safar</h1>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
<div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img title='V Hotel The Grnad Shoba dining safar' loading='lazy' src="/images/dine/dine-3/dine-3.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining safar1"/>
    </div>
    <div className="carousel-item">
      <img title='V Hotel The Grnad Shoba dining safar' loading='lazy' src="/images/dine/dine-3/dine-3-2.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining safar2"/>
    </div>
    <div className="carousel-item">
      <img title='V Hotel The Grnad Shoba dining safar' loading='lazy' src="/images/dine/dine-3/dine-3-3.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining safar3"/>
    </div>
     
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
          <p>A Safar is our signature indoor restaurant serving a delightful blend of traditional and modern cuisine. With warm interiors and attentive service, it offers a cozy setting to enjoy delicious meals crafted from the finest ingredients. A perfect destination for family dinners, quiet lunches, or a flavorful culinary escape.</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

{/* modal uddan */}
 {modalId === 3 && (
        <div className="modal fade show" style={{ display: "block" }}  aria-labelledby="exampleModalLabel" aria-hidden="false">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5 text-center" id="exampleModalLabel">Udaan</h1>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
<div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img title='V Hotel The Grnad Shoba dining udaan' loading='lazy' src="/images/dine/udaan/udaan1.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining udaan1"/>
    </div>
    <div className="carousel-item">
      <img title='V Hotel The Grnad Shoba dining udaan' loading='lazy' src="/images/dine/udaan/udaan2.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining udaan2"/>
    </div>
    <div className="carousel-item">
      <img title='V Hotel The Grnad Shoba dining udaan' loading='lazy' src="/images/dine/udaan/udaan3.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining udaan3"/>
    </div>
    
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
 <p>Udaan, located near the airport, is aptly named after the spirit of takeoff. Just like flights soaring high, Udaan lifts your dining experience with delicious food and a welcoming ambiance. Whether you're arriving, departing, or just craving great taste, enjoy a perfect meal inspired by freshness, flavor, and flight.</p>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}


{/*  modal zaika */}
 {modalId === 4 && (
        <div className="modal fade show" style={{ display: "block" }}  aria-labelledby="exampleModalLabel" aria-hidden="false">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5 text-center" id="exampleModalLabel">Zaika</h1>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
<div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img title='V Hotel The Grnad Shoba dining zaika' loading='lazy' src="/images/dine/dine-1/dine-1.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining zaika1 "/>
    </div>
    <div className="carousel-item">
      <img title='V Hotel The Grnad Shoba dining zaika' loading='lazy' src="/images/dine/dine-1/dine-1-2.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining zaika 2"/>
    </div>
    <div className="carousel-item">
      <img title='V Hotel The Grnad Shoba dining zaika' loading='lazy' src="/images/dine/dine-1/dine-1-3.jpg" className="d-block w-100" alt="V Hotel The Grnad Shoba dining zaika 3"/>
    </div>
     
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
                      <p>Zaika brings the bold and diverse tastes of Delhi to your plate, with a special emphasis on irresistible non-vegetarian specialities. Our skilled chefs craft each dish using time-honoured recipes and authentic spices, delivering a true culinary experience. Step into our cosy indoor space and savour the essence of Delhi’s rich food culture perfect for anyone who loves great food.</p>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  )
}
